import type { Product } from '@c214/shared';
import type { ReactNode } from 'react';
import { ProductRow } from './ProductRow';

interface Props {
  products: Product[];
  title: string;
  counterLabel: string;
  emptyText: string;
  filters?: ReactNode;
}

export function ProductList({ products, title, counterLabel, emptyText, filters }: Props) {
  return (
    <section className="section-pad">
      <div className="mb-8 flex flex-wrap items-baseline justify-between gap-4">
        <h1 className="m-0 text-[clamp(32px,6vw,72px)] font-extrabold tracking-[-0.045em]">
          {title}
        </h1>
        <p className="mono-label">
          {counterLabel}: {products.length}
        </p>
      </div>

      {filters}

      <div className="flex gap-4 border-b border-line py-[14px] font-mono text-[10px] uppercase tracking-[0.12em] text-muted-2">
        <span className="w-[52px] shrink-0" />
        <span className="min-w-40 flex-[2]">Сорт</span>
        <span className="min-w-[120px] flex-[1.4]">Ноти</span>
        <span className="w-[84px] shrink-0">Профіль</span>
        <span className="w-[84px] shrink-0">250 г</span>
        <span className="w-10 shrink-0" />
        <span className="w-[112px] shrink-0" />
      </div>

      {products.length === 0 ? (
        <p className="py-10 text-[15px] text-muted">{emptyText}</p>
      ) : (
        products.map((product) => <ProductRow key={product.id} product={product} />)
      )}
    </section>
  );
}
